import type { ClientGroupDeleteRequest } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useQueryClient } from '@tanstack/react-query';

import { API_CACHE_KEYS } from '@/features/api/constants/cache';
import { useGrapevineGroupEventsApi } from '@/features/api/hooks/grapevine-group-events/useGrapevineGroupEventsApi';
import { useApiMutation } from '@/features/api/hooks/useApiMutation';

export const useDeleteGroup = () => {
  const queryClient = useQueryClient();
  const api = useGrapevineGroupEventsApi();

  return useApiMutation({
    mutationFn: (clientGroupDeleteRequest: ClientGroupDeleteRequest) =>
      api.onGroupDeleteRequest({ clientGroupDeleteRequest }),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: [API_CACHE_KEYS.GROUPS] })
  });
};
